import { render } from "./BlockCompany.vue?vue&type=template&id=4e9cae20&scoped=true"
import script from "./BlockCompany.vue?vue&type=script&lang=js"
export * from "./BlockCompany.vue?vue&type=script&lang=js"

import "./BlockCompany.vue?vue&type=style&index=0&id=4e9cae20&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9cae20"]])

export default __exports__